import { replace } from 'lodash/fp';

const truncateFrequency = (frequency: string) => replace('ly', '', frequency);

export default truncateFrequency;
